var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "grey lighten-5 pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { attrs: { "no-gutters": "" } },
        [
          _c(
            "v-navigation-drawer",
            {
              attrs: {
                temporary: _vm.isMobilePort,
                "mobile-breakpoint": 600,
                app: "",
                clipped: "",
                width: _vm.isMobilePort ? "100%" : 360,
              },
              model: {
                value: _vm.filterDrawer,
                callback: function ($$v) {
                  _vm.filterDrawer = $$v
                },
                expression: "filterDrawer",
              },
            },
            [
              _c("filters", {
                key: _vm.activeFilters.tags
                  ? _vm.activeFilters.tags.join(",")
                  : "",
                attrs: {
                  filters: _vm.filters,
                  userProfileType: _vm.userProfileType,
                  "default-filters": _vm.activeFilters,
                  "apply-instant-filters": !_vm.isMobilePort,
                },
                on: {
                  close: function ($event) {
                    _vm.filterDrawer = false
                  },
                  "apply-filters": _vm.applyFilters,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { width: "100%" } },
            [
              _c("notes-header", {
                attrs: {
                  pagination: _vm.pagination,
                  sectionsCount: _vm.totalSectionCount,
                },
                on: { onPrintClick: _vm.onPrintClick },
              }),
              _vm._v(" "),
              _c(
                "v-container",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.anyFetching,
                      expression: "!anyFetching",
                    },
                  ],
                  staticClass: "content-container container-height",
                  class: !_vm.isMobilePort ? "px-5" : "",
                  attrs: { fluid: "" },
                },
                [
                  _c(
                    "v-overlay",
                    { attrs: { value: _vm.anyFetching, absolute: "" } },
                    [
                      _c("v-progress-circular", {
                        attrs: { indeterminate: "", size: "64" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { attrs: { align: "center", justify: "space-between" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: _vm.isMobilePort ? 12 : 6 } },
                        [
                          _c("count-message", {
                            attrs: {
                              currentSection: _vm.currentSection,
                              totalSectionCount: _vm.totalSectionCount,
                              totalNotes: _vm.totalNotesCount,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          class: {
                            "d-flex justify-end": !_vm.isMobilePort,
                          },
                        },
                        [
                          _vm.isMobilePort
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "mb-5",
                                  attrs: { block: "", outlined: "" },
                                  on: {
                                    click: function ($event) {
                                      _vm.filterDrawer = true
                                    },
                                  },
                                },
                                [
                                  _c("v-icon", { attrs: { left: "" } }, [
                                    _vm._v("mdi-filter-variant"),
                                  ]),
                                  _vm._v(
                                    "\n                            Filters\n                        "
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("v-select", {
                            class: _vm.isMobilePort ? "mb-5" : "mr-2",
                            style: {
                              maxWidth: _vm.isMobilePort ? "100%" : "200px",
                            },
                            attrs: {
                              items: _vm.groupByOptions,
                              "item-text": "text",
                              "item-value": "value",
                              label: "Group by",
                              block: _vm.isMobilePort,
                              dense: "",
                              "hide-details": "",
                              outlined: "",
                              "menu-props": { bottom: true, offsetY: true },
                            },
                            on: { change: _vm.getResults },
                            model: {
                              value: _vm.selectedGroupBy,
                              callback: function ($$v) {
                                _vm.selectedGroupBy = $$v
                              },
                              expression: "selectedGroupBy",
                            },
                          }),
                          _vm._v(" "),
                          _c("v-select", {
                            class: _vm.isMobilePort ? "mb-5" : "",
                            style: {
                              maxWidth: _vm.isMobilePort ? "100%" : "200px",
                            },
                            attrs: {
                              items: _vm.sortOptions,
                              "item-text": "text",
                              "item-value": "value",
                              label: "Sort by",
                              block: _vm.isMobilePort,
                              dense: "",
                              "hide-details": "",
                              outlined: "",
                              "menu-props": { bottom: true, offsetY: true },
                            },
                            on: { change: _vm.getResults },
                            model: {
                              value: _vm.selectedSort,
                              callback: function ($$v) {
                                _vm.selectedSort = $$v
                              },
                              expression: "selectedSort",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("active-filter-chips", {
                    staticClass: "mb-6",
                    attrs: {
                      "is-loading": _vm.anyFetching,
                      filters: _vm.filters,
                      "active-filters": _vm.activeFilters,
                    },
                    on: {
                      "clear-group": _vm.clearGroupFilter,
                      "remove-single-filter": _vm.removeSingleFilter,
                    },
                  }),
                  _vm._v(" "),
                  _vm.isContentView
                    ? _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            [
                              _vm.contentSections.length
                                ? _c("default-content-section-controller", {
                                    attrs: {
                                      highlightType: "add-note",
                                      "content-sections": _vm.contentSections,
                                      "is-notes-section-expanded": true,
                                    },
                                    on: {
                                      sectionSortOrderChanged:
                                        _vm.sectionSortOrderChanged,
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  this.isTitleView
                    ? _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            [
                              _c("v-divider"),
                              _vm._v(" "),
                              !_vm.isLoadingTitleContent && !_vm.titles.length
                                ? _c("notes-not-found")
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-expansion-panels",
                                {
                                  staticClass: "notes-expansion-panel-new",
                                  attrs: { accordion: "" },
                                  model: {
                                    value: _vm.activeTitlePanel,
                                    callback: function ($$v) {
                                      _vm.activeTitlePanel = $$v
                                    },
                                    expression: "activeTitlePanel",
                                  },
                                },
                                _vm._l(_vm.titles, function (title, i) {
                                  return _c(
                                    "v-expansion-panel",
                                    {
                                      key: i,
                                      staticClass: "bg-transparent elevation-0",
                                    },
                                    [
                                      _c(
                                        "v-expansion-panel-header",
                                        {
                                          staticClass: "title-expansion-header",
                                          class: _vm.isMobilePort
                                            ? "px-0 py-4"
                                            : "",
                                          staticStyle: { gap: "10px" },
                                          attrs: { "hide-actions": "" },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { staticClass: "text--secondary" },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.activeTitlePanel === i
                                                      ? "mdi-chevron-down"
                                                      : "mdi-chevron-right"
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("graphic", {
                                            attrs: {
                                              displayOnlyTopicIcon: true,
                                              additionalClasses: "d-flex",
                                              title: title,
                                              thumbnail: "",
                                              width: "24px",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              style: _vm.isMobilePort
                                                ? "display: contents"
                                                : "",
                                            },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(title.display_title)
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-expansion-panel-content",
                                        [
                                          _vm.isLoadingTitleContent &&
                                          _vm.activeTitleId ===
                                            title.document_id
                                            ? _c(
                                                "loading",
                                                { staticClass: "py-2" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-h6 font-weight-medium",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Loading your notes..."
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.isLoadingTitleContent &&
                                          _vm.activeTitleId ===
                                            title.document_id
                                            ? _c("count-message", {
                                                staticClass: "py-3",
                                                attrs: {
                                                  currentSection:
                                                    _vm.titleContentSections[
                                                      title.document_id
                                                    ]?.length,
                                                  totalSectionCount:
                                                    _vm.pagination.total,
                                                  totalNotes:
                                                    _vm.getSectionNoteBookmarksCount,
                                                },
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.isLoadingTitleContent &&
                                          _vm.activeTitleId ===
                                            title.document_id &&
                                          _vm.titleContentSections[
                                            title.document_id
                                          ]?.length
                                            ? _c(
                                                "default-content-section-controller",
                                                {
                                                  attrs: {
                                                    "content-sections":
                                                      _vm.titleContentSections[
                                                        title.document_id
                                                      ],
                                                    highlightType: "add-note",
                                                    "is-notes-section-expanded": true,
                                                    registerDialogs:
                                                      _vm.activeTitleId ===
                                                      title.document_id
                                                        ? true
                                                        : false,
                                                  },
                                                  on: {
                                                    sectionSortOrderChanged:
                                                      _vm.sectionSortOrderChanged,
                                                  },
                                                }
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.isLoadingTitleContent &&
                                          _vm.activeTitleId ===
                                            title.document_id &&
                                          !_vm.titleContentSections[
                                            title.document_id
                                          ]?.length
                                            ? _c("notes-not-found")
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.isLoadingTitleContent &&
                                          _vm.activeTitleId ===
                                            title.document_id &&
                                          _vm.titleContentSections[
                                            title.document_id
                                          ]?.length < _vm.pagination.total
                                            ? [
                                                _c("show-next", {
                                                  attrs: {
                                                    isMoreLoading:
                                                      _vm.isMoreLoading,
                                                    showNext: _vm.showNext,
                                                  },
                                                  on: {
                                                    loadMore: _vm.loadMore,
                                                  },
                                                }),
                                              ]
                                            : _vm._e(),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  )
                                }),
                                1
                              ),
                              _vm._v(" "),
                              _c("v-divider"),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isContentView && _vm.contentSections.length === 0
                    ? [
                        _vm.anyFetching
                          ? _c("loading", [
                              _c(
                                "span",
                                { staticClass: "text-h6 font-weight-medium" },
                                [_vm._v("Loading your notes...")]
                              ),
                            ])
                          : _vm.pagination.total === 0
                          ? _c("notes-not-found")
                          : _vm._e(),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _vm.anyFetching
                ? _c(
                    "v-container",
                    {
                      staticClass: "content-container container-height",
                      attrs: { fluid: "" },
                    },
                    [
                      _c("loading", [
                        _c(
                          "span",
                          { staticClass: "text-h6 font-weight-medium" },
                          [_vm._v("Loading your notes...")]
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.contentSections.length < _vm.pagination.total &&
              _vm.isContentView
                ? [
                    _c("show-next", {
                      attrs: {
                        isMoreLoading: _vm.isMoreLoading,
                        showNext: _vm.showNext,
                      },
                      on: { loadMore: _vm.loadMore },
                    }),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }